module.exports = __webpack_public_path__ + "static/media/applePodcastBadge.dc76932a.jpg";